// Paleta categórica validada (skill dataviz — references/palette.md), ordem
// fixa, nunca ciclada por acaso: passa em todos os checks de CVD (ΔE >= 8
// adjacente) e visão normal (ΔE >= 15 adjacente) no modo claro, o único modo
// que este painel usa (não existe alternância de tema aqui). Slots aqua/
// amarelo/magenta ficam abaixo de 3:1 de contraste contra o fundo — por isso
// nunca usados pra texto, só pra preenchimento de barra (ver GraficoBarras.js,
// que sempre desenha o rótulo com cor calculada a partir do preenchimento).
export const PALETA_CATEGORICA = [
  '#2a78d6', // azul
  '#eb6834', // laranja
  '#1baf7a', // água
  '#eda100', // amarelo
  '#e87ba4', // magenta
  '#008300', // verde
  '#4a3aa7', // violeta
  '#e34948' // vermelho
];

export const TEXTO_PRIMARIO = '#0b0b0b';
export const TEXTO_SECUNDARIO = '#52514e';
export const TEXTO_MUTED = '#898781';
export const GRADE = '#e1e0d9';
export const SUPERFICIE = '#fcfcfb';

export const corPorIndice = (indice) => PALETA_CATEGORICA[indice % PALETA_CATEGORICA.length];
